export default __webpack_public_path__ + "static/media/phoenix-announcement-disabled-icon.65539bbb.svg";